import { i18n } from '@lingui/core';

// Load every .po catalog (base + one per page) through the Vite Lingui plugin.
// Eager import keeps activation synchronous, exactly like the previous static
// `.mjs` imports, but the glob maintains itself: adding a catalog needs no
// change here and no `lingui compile` step.
const modules = import.meta.glob('./locales/*/*.po', {
  eager: true,
}) as Record<string, { messages: Record<string, string> }>;

// Merge every catalog of a locale into a single message map.
const catalogsByLocale = Object.entries(modules).reduce<
  Record<string, Record<string, string>>
>((acc, [path, mod]) => {
  // path looks like ./locales/<locale>/<catalog>.po
  const locale = path.split('/')[2];
  acc[locale] = { ...acc[locale], ...mod.messages };
  return acc;
}, {});

/** Load all catalogs and activate the given locale for Lingui. */
export const activateLocale = (locale: string): void => {
  i18n.load(catalogsByLocale);
  i18n.activate(locale);
};
